module.exports = __webpack_public_path__ + "static/media/Twitter-X-Logo.c2f39012.png";